import { PUBLIC_TOKENS_API_URL } from 'constants/ApiConstants';
import type { ApiError, MetaAction } from 'modules/global/generic.types';
import { filterRequestFormatter } from 'modules/interventions/utils';
import * as types from 'modules/publicToken/actionTypes';
import type * as PublicTokenType from 'modules/publicToken/types';

export const fetchPublicTokens = (
  params: PublicTokenType.PublicTokenDashboardTarget,
  meta: MetaAction = {}
): PublicTokenType.FetchPublicTokensAction => ({
  type: types.FETCH_PUBLIC_TOKEN,
  payload: {
    request: {
      method: 'GET',
      url: `${PUBLIC_TOKENS_API_URL}/filter`,
      params: filterRequestFormatter(params),
    },
  },
  meta: {
    '@app-request': true,
    ...meta,
  },
});

export const createPublicToken = (
  data: PublicTokenType.PublicTokenCreationPayload,
  meta: MetaAction = {}
): PublicTokenType.CreatePublicTokenAction => ({
  type: types.CREATE_PUBLIC_TOKEN,
  payload: {
    request: {
      method: 'POST',
      url: PUBLIC_TOKENS_API_URL,
      data,
    },
  },
  meta,
});

export const updatePublicTokenStatus = (
  publicTokenId: string,
  shouldEnable: boolean,
  meta: MetaAction = {}
): PublicTokenType.PatchPublicTokenStatusAction => {
  const status = shouldEnable ? 'enable' : 'disable';

  return {
    type: types.UPDATE_PUBLIC_TOKEN_STATUS,
    payload: {
      request: {
        method: 'PATCH',
        url: `${PUBLIC_TOKENS_API_URL}/${encodeURIComponent(publicTokenId)}/${status}`,
      },
      publicTokenId,
    },
    meta,
  };
};

export const deletePublicToken = (
  publicTokenId: string,
  meta: MetaAction = {}
): PublicTokenType.DeletePublicTokenAction => ({
  type: types.DELETE_PUBLIC_TOKEN,
  payload: {
    publicTokenId,
    request: {
      method: 'DELETE',
      url: `${PUBLIC_TOKENS_API_URL}/${encodeURIComponent(publicTokenId)}`,
    },
  },
  meta,
});

export const deletePublicTokenSuccess = (
  publicTokenId: string,
  meta: MetaAction = {}
): PublicTokenType.DeletePublicTokenSuccessAction => ({
  type: types.DELETE_PUBLIC_TOKEN_SUCCESS,
  payload: publicTokenId,
  meta,
});

export const deletePublicTokenFailure = (
  error: ApiError,
  meta: MetaAction = {}
): PublicTokenType.DeletePublicTokenFailureAction => ({
  type: types.DELETE_PUBLIC_TOKEN_FAILURE,
  payload: error,
  error: true,
  meta,
});

export const updatePublicTokenStatusFailure = (
  error: ApiError,
  meta: MetaAction = {}
): PublicTokenType.PatchPublicTokenStatusFailureAction => ({
  type: types.UPDATE_PUBLIC_TOKEN_STATUS_FAILURE,
  payload: error,
  error: true,
  meta,
});
